// UChicago's undergraduate majors (#2652). Read on 2026-10-01 from the
// College Catalog 2026-2027, Programs of Study, "List of Majors"
// (collegecatalog.uchicago.edu/thecollege/programsofstudy/). The College has
// no separate schools for undergraduates, so this is one group. The list
// names no degree (some majors award a BA, some a BA or BS), so degree is
// left blank. The left-hand menu also names programs that are minors only
// (e.g. Norwegian Studies, Yiddish Studies); only the List of Majors is used.
// Students declare a major by the end of the second year. The KB's majors
// list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-chicago",
    "read": "2026-10-01",
    "intro": "Every major in the College Catalog 2026-2027's official List of Majors. The catalog names no degree beside each major, so none is shown here. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Majors in the College",
            "source": {
                "label": "UChicago College Catalog 2026-2027, Programs of Study",
                "url": "https://collegecatalog.uchicago.edu/thecollege/programsofstudy/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Archaeology",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Astrophysics",
                    "degree": null
                },
                {
                    "name": "Biological Chemistry",
                    "degree": null
                },
                {
                    "name": "Biological Sciences",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Cinema and Media Studies",
                    "degree": null
                },
                {
                    "name": "Classical Studies",
                    "degree": null
                },
                {
                    "name": "Climate and Sustainable Growth",
                    "degree": null
                },
                {
                    "name": "Cognitive Science",
                    "degree": null
                },
                {
                    "name": "Comparative Human Development",
                    "degree": null
                },
                {
                    "name": "Comparative Literature",
                    "degree": null
                },
                {
                    "name": "Computational and Applied Mathematics",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Creative Writing",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "East Asian Languages and Civilizations",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English Language and Literature",
                    "degree": null
                },
                {
                    "name": "Environment, Geography, and Urbanization",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Fundamentals: Issues and Texts",
                    "degree": null
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": null
                },
                {
                    "name": "Geophysical Sciences",
                    "degree": null
                },
                {
                    "name": "Germanic Studies",
                    "degree": null
                },
                {
                    "name": "Global Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History, Philosophy, and Social Studies of Science and Medicine",
                    "degree": null
                },
                {
                    "name": "Human Rights",
                    "degree": null
                },
                {
                    "name": "Inquiry and Research in the Humanities",
                    "degree": null
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": null
                },
                {
                    "name": "Law, Letters, and Society",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Media Arts and Design",
                    "degree": null
                },
                {
                    "name": "Medieval Studies",
                    "degree": null
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": null
                },
                {
                    "name": "Molecular Engineering",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Public Policy Studies",
                    "degree": null
                },
                {
                    "name": "Race, Diaspora, and Indigeneity",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Romance Languages and Literatures",
                    "degree": null
                },
                {
                    "name": "Russian and East European Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "South Asian Languages and Civilizations",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Theater and Performance Studies",
                    "degree": null
                },
                {
                    "name": "Visual Arts",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
